/**
 * Agent Hub — public locator vocabulary for ETL v3 tours.
 *
 * Tour authors reference aliases via `@plugin.agent-hub:NAME` (qualified)
 * or `@:NAME` (active plugin). When the plugin team renames a testid,
 * update this file — tours keep working.
 */

import type { TourLocatorVocabulary } from '@empowernow/etl-tour';

export const AGENT_HUB_LOCATORS: TourLocatorVocabulary = {
  /* ─── Main tab bar (shared across views) ─────────────────────── */
  'nav.tabs': { testid: 'tab-nav' },
  'nav.tab-gallery': { testid: 'tab-gallery' },
  'nav.tab-discovery': { testid: 'tab-discovery' },
  'nav.tab-triage': { testid: 'tab-triage' },
  'nav.tab-connected': { testid: 'tab-connected' },
  'nav.tab-management': { testid: 'tab-management' },
  'nav.tab-analytics': { testid: 'tab-analytics' },
  'nav.tab-admin': { testid: 'tab-admin' },

  /* ─── Agent gallery (/agents) ──────────────────────────────── */
  'gallery.root': { testid: 'agent-gallery' },
  'gallery.search': { testid: 'search-input' },
  'gallery.filter-bar': { testid: 'gallery-filter-bar' },
  'gallery.primary-action': { testid: 'primary-action-button' },
  'gallery.import': { testid: 'agent-gallery-import-btn' },

  /* ─── Discovery inbox (/agents/discovery) ────────────────────── */
  'discovery.root': { testid: 'discovery-inbox' },
  'discovery.filter-needs-review': { testid: 'discovery-filter-needs-review' },
  'discovery.filter-federated': { testid: 'discovery-filter-federated' },
  'discovery.filter-all': { testid: 'discovery-filter-all' },
  'discovery.search': { testid: 'discovery-search' },
  'discovery.enroll-selected': { testid: 'discovery-enroll-selected' },
  'discovery.provider-rollup': { testid: 'discovery-provider-rollup' },

  /* ─── Delegations (/agents/delegations) ──────────────────────── */
  'delegations.root': { testid: 'delegations-root' },
  'delegations.welcome': { testid: 'ah-welcome-tour' },
  'delegations.search': { testid: 'delegations-search-input' },
  'delegations.filter-controls': { testid: 'delegations-filter-controls' },
  'delegations.table': { testid: 'delegations-table' },
};
